/**
 * Small SSR-safe localStorage helper for remembering the user's recent
 * searches, surfaced in the Topbar keyword autocomplete when the input is
 * focused and empty.
 *
 * Each entry has the shape { label, searchParams } so a recent search can be
 * re-run exactly (a plain keyword search or a facet filter).
 */

const STORAGE_KEY = 'app_recent_searches';
const MAX_RECENT = 5;

const isBrowser = () => typeof window !== 'undefined' && !!window.localStorage;

export const getRecentSearches = () => {
  if (!isBrowser()) {
    return [];
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter(e => e && e.label) : [];
  } catch (e) {
    return [];
  }
};

export const addRecentSearch = entry => {
  if (!isBrowser() || !entry || !entry.label) {
    return getRecentSearches();
  }
  try {
    const label = `${entry.label}`.trim();
    if (!label) {
      return getRecentSearches();
    }
    const existing = getRecentSearches();
    // Dedupe case-insensitively by label, newest first, capped.
    const deduped = existing.filter(
      e => e.label.toLowerCase() !== label.toLowerCase()
    );
    const next = [{ label, searchParams: entry.searchParams || {} }, ...deduped].slice(
      0,
      MAX_RECENT
    );
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  } catch (e) {
    return getRecentSearches();
  }
};

export const clearRecentSearches = () => {
  if (!isBrowser()) {
    return;
  }
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // ignore
  }
};
